import { Box, Grid, styled, Typography } from "@mui/material";

import Switch from "components/Switch";
import Select from "components/Select";
import ToggleView from "./ToggleView";
import { applicationUserPaymentFeeWithUSDT } from "store/slices/user/userSlice";
import useDispatch from "hooks/useDispatch";
import useIsMobileView from "hooks/useIsMobileView";
import { useSelector } from "react-redux";
import CoinSelectItem from "pages/Wallet/Component/FilterMarginHistory/Component/CoinSelectItem";

export function ActionTable({
  setLimit,
  limit,
  setActiveView,
  activeView,
  valueBalance,
  seValueBalance,
  isSpot,
}) {
  const dispatch = useDispatch();
  const isMobileView = useIsMobileView();

  const user = useSelector((state) => state.user.user?.data);

  const handleChangeValueBalance = (e) => {
    const value = e.target.value;
    seValueBalance(value);
  };

  const listValueBalance = [
    { id: 0, name: "USDT", imageUrl: "/images/coin/usdt.png" },
    { id: 1, name: "Toman", imageUrl: "/images/coin/toman.png" },
  ];

  return (
    <Grid
      container
      spacing={2}
      display={"flex"}
      marginBottom={2.3}
      paddingLeft={1}
      paddingRight={1}
    >
      <GridSwitch item sm={8} xs={12}>
        <Switch
          checked={user?.isPaymentFeeWithUSDT}
          onChange={(e) => {
            const body = new FormData();
            body.append("IsPaymentFeeWithUSDT", e.target.checked);

            dispatch(applicationUserPaymentFeeWithUSDT(body));
          }}
          label="USDT Fee"
          color="secondary"
        />

        <Switch
          checked={limit}
          onChange={(e) => {
            setLimit(e.target.checked);
          }}
          label="Show More"
          color="secondary"
        />

        <BoxValueBalance>
          <Typography variant="h6" mr={1} color="text.main" width="100%">
            {isSpot ? "Value Balance" : "Equity Balance"}
          </Typography>

          <SelectStyle
            items={listValueBalance}
            itemValue="id"
            itemText="name"
            value={valueBalance}
            dir="ltr"
            onChange={handleChangeValueBalance}
            customValue={(data) => <CoinSelectItem data={data} />}
          />
        </BoxValueBalance>
      </GridSwitch>

      {!isMobileView && (
        <GridFieldView item sm={4}>
          <ToggleView onChange={setActiveView} value={activeView} />
        </GridFieldView>
      )}
    </Grid>
  );
}

const GridFieldView = styled(Grid)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "end",
  [theme.breakpoints.down("sm")]: {
    display: "none",
  },
  ".MuiButtonBase-root": {
    minWidth: "auto",
    minHeight: "auto",
  },
  "ion-icon": {
    minWidth: "20px",
    minHeight: "20px",
  },
}));

const GridSwitch = styled(Grid)(({ theme }) => ({
  display: "flex",
  alignItems: "center",

  [theme.breakpoints.down("sm")]: {
    flexDirection: "column",
  },
}));

const BoxValueBalance = styled(Box)(({ theme }) => ({
  display: "flex",
  paddingLeft: "30px",
  alignItems: "center",
  [theme.breakpoints.down("sm")]: {
    width: " 100%",
    paddingLeft: "0px",
  },
}));

const SelectStyle = styled(Select)(({ theme }) => ({
  textAlign: "center",
  ".MuiSelect-select": {
    padding: theme.spacing(0.5, 2.5),
    fontSize: "12px",
  },
  minWidth: " 135px",
  [theme.breakpoints.down("sm")]: {
    maxWidth: "135px",
  },
}));
export default ActionTable;
